import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './action.js'

Vue.use(Vuex)

const state = {
  start: 500,
  end: 1000,
  showHome: true,
  showContainer: false,
  showResult: false,
  Nmax: 500,
  islogin: false,
  motionNum: 0,
  userName: '',
  vocabulary: '0',
  allQuestions: '0',
  rightAnswer: '0',
  wrongAnswer: '0',
  firstWorng: false,
  notKnow: '0',
  rightIndex: '',
  lastVocabulary: 0,
  sharePage: false,
  firstChiose: true,
  desc: '',
  bookList: '',
  wrongIndex: 0
}
const getters = {
  lastVocabulary: state => {
    return state.lastVocabulary
  },
  allQuestions: state => {
    return state.allQuestions
  },
  bookList: state => {
    return state.bookList
  },
  showResult: state => {
    return state.showResult
  },
  wrongAnswer: state => {
    return state.wrongAnswer
  },
  islogin: state => {
    return state.islogin
  }
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js